var map = {
	"./Framabag.vue": 106,
	"./Framabee.vue": 104,
	"./Framabin.vue": 107,
	"./Framaboard.vue": 108,
	"./Framabookin.vue": 109,
	"./Framacalc.vue": 110,
	"./Framaclic.vue": 111,
	"./Framadrop.vue": 112,
	"./Framaestro.vue": 113,
	"./Framalink.vue": 114,
	"./Framanews.vue": 115,
	"./Framanotes.vue": 116,
	"./Framapic.vue": 117,
	"./Framasite.vue": 118,
	"./Framaslides.vue": 119,
	"./Framasphere.vue": 120,
	"./Framastory.vue": 121,
	"./Framavectoriel.vue": 122,
	"./Framawiki.vue": 123,
	"./Framemo.vue": 124,
	"./Framindmap.vue": 125,
	"./Home.vue": 105,
	"./Myframa.vue": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;